import { useState, useEffect } from 'react';
import { getEventDetailsData } from '@op/services/summary';
import { IEventItem, TSentimentType } from '../types';

interface IUseEventDetailsDataProps {
  taskId: string;
  sentimentType: TSentimentType;
}

interface IUseEventDetailsDataReturn {
  /** 事件列表（API 已按 sentiment_type 过滤） */
  eventList: IEventItem[];
  /** 列表加载状态 */
  listLoading: boolean;
  /** API 返回的开始时间 */
  startTime: string;
  /** API 返回的结束时间 */
  endTime: string;
}

/**
 * EventDetails 页面数据 Hook — 调用 advanced/event_list 获取事件列表
 * API 端已按 sentiment_type 过滤并排序
 */
export default function useEventDetailsData({
  taskId,
  sentimentType,
}: IUseEventDetailsDataProps): IUseEventDetailsDataReturn {
  const [eventList, setEventList] = useState<IEventItem[]>([]);
  const [listLoading, setListLoading] = useState(false);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');

  useEffect(() => {
    if (!taskId) return;

    setListLoading(true);
    getEventDetailsData({
      task_id: taskId,
      sentiment_type: sentimentType,
    })
      .then((data: any) => {
        const { list, start_time: apiStartTime, end_time: apiEndTime } = data || {};
        setEventList(list || []);
        setStartTime(apiStartTime || '');
        setEndTime(apiEndTime || '');
      })
      .finally(() => {
        setListLoading(false);
      });
  }, [taskId, sentimentType]);

  return {
    eventList,
    listLoading,
    startTime,
    endTime,
  };
}
